module.exports = __webpack_public_path__ + "static/media/pink-cluster.5aadba02.svg";